export interface KeyValueRecord<V = unknown> {
  key: string;
  value: V;
}

/** Helper to turn { k: v } into [{ key:k, value:v }] */
export const recordToKvArray = (obj?: Record<string, unknown>) =>
  obj ? Object.entries(obj).map(([key, value]) => ({ key, value })) : [];

/** Generic getter: param is unknown[], return is typed by <V> */
export const findKvRecordValue = <V>(records: readonly KeyValueRecord[], key: string): V | null => {
  const rec = records.find((r) => r.key === key);
  return rec ? (rec.value as V) : null;
};
